<template>
  <router-link :to="to" :target="target">
    <slot />
  </router-link>
</template>
<script>
import { USERS_URL } from '@/modules/user/user.constants';

export default {
  name: 'DaraUserLink',
  props: {
    id: {
      type: String,
      required: true,
    },
    target: {
      type: String,
      default: '',
    },
    action: {
      type: String,
      default: 'view',
      validator(action) {
        return action && ['view', 'edit'].includes(action);
      },
    },
  },
  computed: {
    to() {
      return {
        name: USERS_URL[this.action].name,
        path: USERS_URL[this.action].path,
        params: {
          id: this.id,
        },
      };
    },
  },
};
</script>
